<template>
  <div class="container">
    <div class="content-wrapper" :class="{iframe: isViewiFrame}">
      <div class="column-wrapper">
        <div class="form-wrapper">
          <h2>Formularz doładowania</h2>
          <p class="h2-subtitle" v-required-mark>Wymagane pola są oznaczone</p>
          <topup-form :params="formData" />
        </div>
        <topup-guide />
      </div>
    </div>
  </div>
</template>

<script>
import TopupForm from '@/pge/components/Topup/Form'
import TopupGuide from '@/pge/components/Topup/Guide'
import { APP_VIEW } from '@/pge/const/config.const'
import { mapState } from 'vuex'

export default {
  name: 'TopupFormView',
  components: {
    TopupGuide,
    TopupForm
  },
  computed: {
    ...mapState({
      isViewiFrame: state => state.pge.view === APP_VIEW.iframe
    })
  },
  data () {
    return {
      formData: null
    }
  },
  created () {
    if (this.$route.query.code) {
      this.formData = {}
      this.formData.amount = 0
      this.formData.code = this.$route.query.code

      if (this.$route.query.email) {
        this.formData.email = this.$route.query.email
      }
      if (this.$route.query.phone) {
        this.formData.phone = this.$route.query.phone
      }

      if (this.$route.query.amountFirstZone) {
        this.formData.amountFirstZone = parseFloat(this.$route.query.amountFirstZone)
        this.formData.amountSecondZone = this.$route.query.amountSecondZone
          ? parseFloat(this.$route.query.amountSecondZone)
          : null
      }
    }
  }
}
</script>
